import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/react'
import './index.css'
import App from './App.jsx'

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
export const AUTH_BYPASS = import.meta.env.VITE_AUTH_BYPASS === 'true'
export const AUTH_MODE = AUTH_BYPASS ? 'bypass' : import.meta.env.VITE_AUTH_MODE || 'odoo'

// Upright only. "portrait" in the manifest also allows upside down, and Chrome
// on Android follows the sensor for that even with auto-rotate off: tilting a
// scanner downwards flipped the screen. The lock only works in the installed app.
if (window.matchMedia?.('(display-mode: standalone)').matches) {
  screen.orientation?.lock?.('portrait-primary').catch(() => {})
}

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {})
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {AUTH_MODE === 'clerk' ? (
      <ClerkProvider publishableKey={clerkPubKey} afterSignOutUrl="/login">
        <App />
      </ClerkProvider>
    ) : (
      <App />
    )}
  </StrictMode>,
)
